import { Controller } from "@hotwired/stimulus";

/**
 * Identifier Form Controller
 *
 * Handles showing/hiding the custom type field based on ID type selection
 */
export default class extends Controller {
  static targets = ["customTypeField", "autofocus"];

  connect() {
    setTimeout(() => {
      if (this.hasAutofocusTarget) {
        this.autofocusTarget.focus();
      }
    }, 300);
  }

  toggleCustomType(event) {
    const isOther = event.target.value === "other";
    this.customTypeFieldTarget.style.display = isOther ? "block" : "none";
  }
}
